import React from 'react';

import { getConversionFunnel } from '../../../services/eventAnalyticsService';

const ConversionFunnel = () => {
  const funnel = getConversionFunnel();

  return (
    <div className="bg-card border border-border rounded-xl p-6">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h3 className="text-base font-semibold text-foreground">Conversion Funnel</h3>
          <p className="text-xs text-muted-foreground mt-0.5">End-to-end form journey drop-off</p>
        </div>
        <span className="text-xs bg-primary/10 text-primary px-2.5 py-1 rounded-full font-medium">
          34.7% overall
        </span>
      </div>
      {/* Funnel bars */}
      <div className="space-y-3">
        {funnel?.map((stage, idx) => (
          <div key={stage?.stage}>
            <div className="flex items-center justify-between mb-1">
              <span className="text-xs text-muted-foreground font-medium">{stage?.stage}</span>
              <div className="flex items-center gap-3">
                <span className="text-xs text-foreground font-semibold">{stage?.count?.toLocaleString()}</span>
                <span className="text-xs text-muted-foreground w-10 text-right">{stage?.pct}%</span>
              </div>
            </div>
            <div className="h-7 bg-muted rounded-lg overflow-hidden relative">
              <div
                className="h-full rounded-lg transition-all duration-700 flex items-center justify-end pr-2"
                style={{ width: `${stage?.pct}%`, backgroundColor: stage?.color }}
              >
                {stage?.pct > 15 && (
                  <span className="text-[10px] text-white font-semibold">{stage?.pct}%</span>
                )}
              </div>
            </div>
            {idx < funnel?.length - 1 && (
              <div className="flex items-center gap-1 mt-1 ml-1">
                <span className="text-[10px] text-error">
                  ↓ {(funnel?.[idx]?.count - funnel?.[idx + 1]?.count)?.toLocaleString()} dropped
                </span>
                <span className="text-[10px] text-muted-foreground">
                  ({(100 - (funnel?.[idx + 1]?.count / funnel?.[idx]?.count * 100))?.toFixed(1)}% drop-off)
                </span>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ConversionFunnel;
